module.exports = __webpack_public_path__ + "icon_header_ru.png?af80d391a6a9214e492e6e21d16a4778";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_header_ru.png
// module id = 216
// module chunks = 0